import React from 'react'
import { Helmet } from 'react-helmet-async'

import { getFirstBannerImage, getLcpPreloadLinks } from 'utils/lcpPreload'

interface LcpPreloadProps {
  flexContent: any
}

const LcpPreload: React.FC<LcpPreloadProps> = ({ flexContent }) => {
  const preloadLinks = getLcpPreloadLinks(getFirstBannerImage(flexContent))

  if (!preloadLinks.length) {
    return null
  }

  return (
    <Helmet>
      {preloadLinks.map((link) => (
        <link
          key={link.media || 'default'}
          rel="preload"
          as="image"
          href={link.href}
          media={link.media}
          {...(link.srcSet
            ? {
                imageSrcSet: link.srcSet,
                imageSizes: link.sizes,
              }
            : {})}
        />
      ))}
    </Helmet>
  )
}

export default LcpPreload
